export default __webpack_public_path__ + "static/media/minus-round.b74c13c0.svg";